export const DEPLOYED_YEAR = "2026";
